import { provideHooks } from "redial";
import {
  fetchSearch,
  getItemCount,
  hasFacets,
  getPaginationData,
  sendPlacementOnLoadBeacon
} from "../../state/modules/search";
import {
  getIsNewSearch,
  getSearchTerm
} from "../../state/modules/search/selectors";
import SearchPage from "./SearchPage";
import { setPageLoading, setIsNewPage } from "../../state/modules/page/actions";
import { analyticsPageLoad } from "../../state/modules/analytics/actions";
import { connect } from "react-redux";
import { getError } from "../../state/modules/error";
import { getStoreUrl } from "../../state/modules/config/selectors";
import {
  clearCategoryDetails,
  clearCuratedCategoryTreatments
} from "../../state/modules/category/actions/";

const isValidSearch = location => {
  const searchTerm =
    new URLSearchParams(location.search).get("q")?.trim().length > 0;

  return searchTerm;
};

export const hooks = {
  fetch: ({ dispatch, location, store, uuid, xSiteOrigin, isNewPage }) => {
    const state = store.getState();
    if (isValidSearch(location)) {
      if (!getIsNewSearch(state)) {
        return;
      }

      return dispatch(fetchSearch(uuid, xSiteOrigin, isNewPage)).then(() => {
        dispatch(setPageLoading(false));
        dispatch(sendPlacementOnLoadBeacon());
        if (isNewPage) {
          dispatch(clearCategoryDetails());
          dispatch(clearCuratedCategoryTreatments());
          dispatch(analyticsPageLoad());
          dispatch(setIsNewPage(false));
        }
      });
    }
  }
};

export function mapStateToProps(state) {
  return {
    hasFacets: hasFacets(state),
    itemCount: getItemCount(state),
    isLoading: state.page.isLoading,
    paginationData: getPaginationData(state),
    searchTerm: getSearchTerm(state),
    error: getError(state),
    storeUrl: getStoreUrl(state)
  };
}

export default provideHooks(hooks)(connect(mapStateToProps, null)(SearchPage));
